import { app_url } from "app_config";
import React from "react";
import { Navigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

const Authmiddleware = (props) => {
  if (!secureLocalStorage.getItem("authUser")) {
    return (
      <Navigate to={{ pathname: `${app_url}login`, state: { from: props.location } }} />
    );
  }
  return (<React.Fragment>
    {props.children}
  </React.Fragment>);
};

export default Authmiddleware;
382891